import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../../../common/MobileGridCards.sass';

const isEmptyValue = (value) => value === undefined || value === null || value.toString().trim() === '';
const displayValue = (value) => (isEmptyValue(value) ? 'N/A' : value);

const DriverEventPerformanceMobileCard = ({ row }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const baseData = [
		{ label: t(('First Name').replace(/\s/g, '_')), value: row.first_name },
		{ label: t(('Last Name').replace(/\s/g, '_')), value: row.last_name },
		{ label: t('Group'), value: row.driver_group },
		{ label: t(('Miles Driven/Event').replace(/\s/g, '_')), value: row.miles_driven_per_event },
		{ label: t(('Miles Driven').replace(/\s/g, '_')), value: row.miles_driven },
	];

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{displayValue(value)}</span>
							</div>
						))}
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default DriverEventPerformanceMobileCard;
